import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  effect,
  inject, input,
  Input,
} from '@angular/core';
import {LanguageService} from "../../../core/language.service";
import {CurrencyPipe} from "@angular/common";
import {RouterLink} from "@angular/router";
import {CurrencyConvertService} from '../../../core/currency.convert.service';
import {IonButton, IonButtons, IonIcon, IonImg} from '@ionic/angular/standalone';
import {AuthService} from '../../../auth/auth.service';
import {TranslateModule} from '@ngx-translate/core';
import {WishListButtonComponent} from '../wish-list-button/wish-list-button.component';



@Component({
    selector: 'app-property-card',
  imports: [
    CurrencyPipe,
    RouterLink,
    IonButton,
    IonIcon,
    IonButtons,
    IonImg,
    TranslateModule,
    WishListButtonComponent
  ],
    templateUrl: './property-card.component.html',
    styleUrl: './property-card.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PropertyCardComponent {
  languageService: LanguageService = inject(LanguageService);
  @Input() innerCard: boolean = false;
  @Input() listingPage: boolean = false;
  @Input() property: any;
  @Input() isHome: any;
  @Input() parentId: string = '';
  @Input() activeId: string = '';
  @Input() parentName: string = '';
  isWishlist = input(false);
  isInWishlist: boolean = false;
  chipColor: string = 'primary' // primary secondary;
  currencyConvertService: CurrencyConvertService = inject(CurrencyConvertService);
  constructor(private userService: AuthService) {
    this.loadSwiper();
    effect(async () => {
      if(this.currencyConvertService.localCurrency()) {
        this.property.newPrice = this.property.price * this.currencyConvertService.exchangeRates[this.currencyConvertService.localCurrency()];
      }
      if (this.isWishlist()) {
        const x: any = await this.userService.isInWishList(this.property._id, this.userService.userSignal()._id);
        this.isInWishlist = x.exists;
      }
    });
  }

  async loadSwiper() {
    const { register } = await import("swiper/element/bundle");
    register();
  }
  async updateWishList(id: string) {
    try {
      await this.userService.updateWishlist(id);
      const x: any = await this.userService.isInWishList(id, this.userService.userSignal()._id);
      this.isInWishlist = x.exists;
    } catch (e) {}
  }
  get queryParams() {
    const params: any = { en: this.property.slug };
    if (this.parentId) {
      params.parentId = this.parentId.toLowerCase();
    }
    if (this.parentName) {
      params.parentName = this.parentName.toLowerCase();
    }
    if (this.property.cityEn) {
      params.city = this.urlFriendly(this.property.cityEn);
    }
    if (this.property.subCityEn) {
      params.sub = this.urlFriendly(this.property.subCityEn);
    }
    return params;
  }
  urlFriendly(text: string) {
    return text.toLowerCase()
      .replace(/[^a-z0-9\s]/g, '') // Remove special characters
      .replace(/\s+/g, '-') // Replace spaces with dashes
      .trim()
  }
}
